// Name of the cookie used to propagate the viewer's IANA timezone from the
// client to the Next.js server. Set by i18nStore's constructor on the client
// and read server-side to pass along as the ``tz`` query param on async block
// fetches so the backend can filter against the viewer's local date rather
// than the Node server's timezone.
export const VIEWER_TZ_COOKIE = "viewer_tz";
